<style scoped>
    .ivu-poptip{
        width: 100%;
    }
    .ivu-poptip /deep/ .ivu-poptip-rel{
        width: 100%;
    }
</style>
<template>
    <div>
        <Poptip @on-popper-show="init">
            <div>
                <div class="text-left" v-show="csw.warehouse_id && !csw.del" v-for="(csw, index) in contract_stock.contract_stock_warehouses" :key="index">
                    <span>{{getWarehouseName(csw.warehouse_id)}}</span>
                    <span>({{csw.qty}})</span>
                </div>
                <div class="link">履约中台分配仓库</div>
            </div>
            <div slot="content">
                <table class="mis-table">
                    <tr>
                        <th>仓库</th>
                        <th>数量</th>
                        <th>操作</th>
                    </tr>
                    <tr v-for="(csw, index) in contract_stock.contract_stock_warehouses" v-if="!csw.del" :key="index">
                        <td>
                            <Select size="small" v-model="csw.warehouse_id" placeholder="选择仓库">
                                <Option :value="wh.id" v-for="wh in warehouses" :key="wh.id">{{wh.name}}</Option>
                            </Select>
                        </td>
                        <td>
                            <i-input size="small" v-model="csw.qty"></i-input>
                        </td>
                        <td>
                            <Button size="small" shape="circle" @click="addItem" icon="md-add" v-if="isLastIndex(index)"></Button>
                            <Poptip
                                confirm
                                title="你确定要删除吗?"
                                @on-ok="delItem(csw, index)"
                                >
                                <Button size="small" shape="circle" icon="md-close" v-if="index > 0"></Button>
                            </Poptip>
                        </td>
                    </tr>
                </table>
                <div class="hr"></div>
                <Button size="small" type="primary" long @click="hidePoptip">确定</Button>
            </div>
        </Poptip>
    </div>
</template>
<script>
    import {mapGetters} from "vuex";

    export default {
        props: {
            contract_stock: {
                type: Object,
                required: true
            }
        },
        data(){
            return {
                //
            }
        },
        computed: {
            cur_customer(){
                return this.$store.state.cur_customer;
            },
            ...mapGetters({
                warehouses: 'async/warehouses',
                warehouses_hash: 'async/warehouses_hash',
            }),
            new_item(){
                return {
                    contract_stock_id: this.contract_stock.id,
                    warehouse_id: 0,
                    qty: 0,
                    del: false
                }
            }
        },
        created(){
            //
        },
        mounted(){
            //
        },
        methods: {
            init(){
                if(this.contract_stock.contract_stock_warehouses.length === 0){
                    this.addItem();
                }
            },
            isLastIndex(index){
                return index === this.contract_stock.contract_stock_warehouses.length - 1;
            },
            addItem(){
                this.contract_stock.contract_stock_warehouses.push(Util.clone(this.new_item));
            },
            delItem(item, index){
                if(item.id){
                    item.del = true;
                }else{
                    this.contract_stock.contract_stock_warehouses.splice(index, 1);
                }
            },
            getWarehouseName(id){
                let wh = this.warehouses_hash[id];
                return wh ? wh.name : '-';
            },
            hidePoptip(){
                document.body.click();
            }
        }
    }
</script>
